import { render, staticRenderFns } from "./AlertList.html?vue&type=template&id=6cfc8a62&scoped=true&"
import script from "./AlertList.vue?vue&type=script&lang=js&"
export * from "./AlertList.vue?vue&type=script&lang=js&"
import style0 from "./AlertList.scss?vue&type=style&index=0&id=6cfc8a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc8a62",
  null
  
)

export default component.exports